import React from 'react';

class Slider extends React.Component {

    constructor(props) {
        super(props);
        this.sliderData = this.props.sliderConfig[this.props.id];
        this.timer = null;
        this.state = {
            pixelPos: 0,
            labelPos: 0,
            sliding: false,
            inputFocused: false,
            inputValue: this.props.state[this.props.id] ? this.props.state[this.props.id] : this.sliderData.min,
        };
        this.updateState = this.props.updateState;
    }

    componentDidMount() {
        if(!this.props.state[this.props.id]) {
            this.updateState({[this.props.id]: this.sliderData.min});
        }
        setTimeout(() => {
            this.calculateSizeAndPos();
            this.setSliderPixelPos();
        }, 0);
        this.sliderData['labelElem'] = document.querySelector("[for='slider-input-"+this.props.id+"']");
        window.addEventListener('mousemove', this.dragging);
        window.addEventListener('touchmove', this.dragging);
        window.addEventListener('mouseup', this.endDrag);
        window.addEventListener('touchend', this.endDrag);
        this.props.resizeFns['slider-'+this.props.id] = this.resizeSlider;
        this.setState({sliding:false});
    }

    componentWillUnmount() {
        delete this.props.resizeFns['slider-'+this.props.id];
        window.removeEventListener('mousemove', this.dragging);
        window.removeEventListener('touchmove', this.dragging);
        window.removeEventListener('mouseup', this.endDrag);
        window.removeEventListener('touchend', this.endDrag);
    }

    resizeSlider = () => {
        this.calculateSizeAndPos();
        this.setSliderPixelPos();
    }

    calculateSizeAndPos() {
        let elem = document.getElementById("slider-line-" + this.props.id);
        if(!elem) return;
        let width = elem.offsetWidth - 22,
            leftEnd = Math.floor(elem.getBoundingClientRect().x || elem.getBoundingClientRect().left),
            rightEnd = leftEnd + width,
            range = this.sliderData.max - this.sliderData.min,
            stepDistance = width / (range / this.sliderData.step);
        this.sliderData['width'] = width;
        this.sliderData['leftEnd'] = leftEnd;
        this.sliderData['rightEnd'] = rightEnd;
        this.sliderData['stepDistance'] = stepDistance;
        this.sliderData['decimals'] = 1;
    }

    startDrag(e) {
        e.persist();
        if(e.target && (e.target.className === 'slider-ball' || e.target.className === 'slider-line')) {
            e.preventDefault();
            this.updateState({
                mouseDownId: this.props.id,
                noUserSelections: true
            });
            this.setState({
                sliding: true
            });
        }
    }

    dragging = (e) => {
        if(this.props.state.mouseDownId === this.props.id) {
            clearTimeout(this.timer);
            let pos = e.touches && e.touches.length ? e.touches[0].clientX : e.clientX,
                posRelative,
                steps,
                curValue;
            if(pos < this.sliderData.leftEnd) {
                pos = this.sliderData.leftEnd;
            } else
            if(pos > this.sliderData.rightEnd) {
                pos = this.sliderData.rightEnd;
            }
            posRelative = pos - this.sliderData.leftEnd;
            steps = Math.round(posRelative / this.sliderData.stepDistance);
            curValue = steps * this.sliderData.step + this.sliderData.min;
            let roundedVal = Number(Math.round(curValue+'e'+1)+'e-'+1);
            this.setState({
                pixelPos: posRelative,
                inputValue: roundedVal
            });
            this.calculateLabelPos();
            this.timer = setTimeout(() => {
                this.updateState({
                    [this.props.id]: roundedVal
                });
                this.setSliderPixelPos();
            },200);
        }
    }

    endDrag = (e) => {
        if(this.props.state.mouseDownId === this.props.id) {
            clearTimeout(this.timer);
            this.updateState({
                mouseDownId: null,
                noUserSelections: false,
                [this.props.id]: this.state.inputValue
            });
            this.setState({
                sliding: false
            });
            this.setSliderPixelPos();
        }
    }

    clickSliderLine = (e) => {
        e.persist();
        this.startDrag(e);
        setTimeout(() => {
            this.dragging(e);
            this.endDrag(e);
        },0);
    }

    setSliderPixelPos(forcedVal) {
        let curVal = forcedVal || forcedVal === 0 ? forcedVal : this.props.state[this.props.id],
            steps, pos;
        if(curVal < this.sliderData.min) {
            curVal = this.sliderData.min;
        } else
        if(curVal > this.sliderData.max) {
            curVal = this.sliderData.max;
        }
        this.updateState({[this.props.id]:curVal});
        steps = (curVal - this.sliderData.min) / this.sliderData.step;
        pos = steps * this.sliderData.stepDistance;
        this.setState({
            pixelPos: pos,
            inputValue: curVal
        });
        setTimeout(() => {
            this.calculateLabelPos();
        },0);
    }

    calculateLabelPos() {
        let labelWidth = this.sliderData.labelElem.getBoundingClientRect().width,
            halfWidth = labelWidth / 2;
        if(this.state.pixelPos - halfWidth + 11 < 0) {
            this.setState({
                labelPos: -(this.state.pixelPos - halfWidth) - 11
            });
        } else 
        if(this.state.pixelPos + halfWidth - 11 > this.sliderData.width) {
            this.setState({
                labelPos: -halfWidth + (this.sliderData.width - this.state.pixelPos) + 11
            });
        } else {
            this.setState({
                labelPos: 0
            });
        }
    }

    labelClick = (e) => {
        e.persist();
        this.setState({
            inputFocused: true,
            inputValue: this.props.state[this.props.id]
        }, () => {
            let elem = document.getElementById("slider-input-" + this.props.id);
            elem.focus();
            elem.setSelectionRange(0, 9999);
        });
    }

    onBlur = (e) => {
        this.setState({
            inputFocused: false
        });
        this.setSliderPixelPos(
            this.sliderData.inputBlur(this.state.inputValue, this.props.state[this.props.id])
        );
    }

    handleChange(e) {
        this.setState({
            inputValue: e.target.value
        });
    }

    showDecimalValue(value) {
        if(value === undefined || value === null) return;
        return value.toString().replace(".", ",");
    }

    render() {
        return (
            <div className={"slider" + (this.state.sliding ? " slider--sliding" : "")}>
                <h4>{this.sliderData.title}</h4>
                <div className="slider-line" id={"slider-line-" + this.props.id} onClick={(e) => {this.clickSliderLine(e)}}>
                    <div className="slider-line--filled" style={{width:this.state.pixelPos+"px"}}></div>
                    <div className="slider-ball"
                         id={"slider-ball-" + this.props.id}
                         onMouseDown={(e) => {this.startDrag(e)}}
                         onTouchStart={(e) => {this.startDrag(e)}}
                         style={{left:this.state.pixelPos+"px"}}>
                        <label className={"slider-label" + (this.state.inputFocused ? " input-focused" : "")}
                               htmlFor={"slider-input-" + this.props.id}
                               style={{marginLeft:this.state.labelPos+"px"}}>
                            <span className="slider-label-text">
                                {this.showDecimalValue(this.state.inputValue) + " " + this.sliderData.unit(this.props.state[this.props.id])}
                            </span>
                            <input className="slider-input"
                                   id={"slider-input-" + this.props.id}
                                   onBlur={(e) => {this.onBlur(e)}}
                                   onFocus={(e) => {this.labelClick(e)}}
                                   value={this.showDecimalValue(this.state.inputValue)}
                                   onKeyPress={(e) => {
                                       e.persist();
                                       if(e.key === "Enter") this.onBlur();
                                   }}
                                   onChange={this.handleChange.bind(this)}
                                   maxLength={this.sliderData.maxlength} />
                        </label>
                    </div>
                </div>
            </div>
        );
    }

}

export default Slider;